import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import { browserHistory } from 'react-router';
import { isBoolean } from 'lodash';

export default class WhitelabelConfigFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      whitelabelConfigId: null,
    });
    this.form.validations = {
      domain: [isRequired],
      title: [isRequired],
      supportEmail: [isRequired],
      isNewStudentAppEnabled: [isRequired],
    };
  }

  handleLoad = action((whitelabelConfigId) => {
    this.form.reset();
    if (whitelabelConfigId) {
      this.fetch
        .fetch({
          url: `/whitelabel-configs/${whitelabelConfigId}`,
        })
        .then(() => {
          if (this.fetch.data) {
            this.form.setInitialValues({ ...this.fetch.data });
          }
        });
    } else {
      this.form.setInitialValues({});
      this.form.validations.logo = [isRequired];
    }
    this.whitelabelConfigId = whitelabelConfigId;
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    const whitelabelConfigId = this.form.getValue('id');

    const formData = new FormData();
    formData.append('domain', this.form.getValue('domain'));
    formData.append('title', this.form.getValue('title'));
    if (this.form.getValue('logo')) {
      formData.append('logoFile', this.form.getValue('logo'));
    }
    if (this.form.getValue('whiteLogo')) {
      formData.append('whiteLogoFile', this.form.getValue('whiteLogo'));
    }
    if (this.form.getValue('studentPrivacyPolicyUrl')) {
      formData.append('studentPrivacyPolicyUrl', this.form.getValue('studentPrivacyPolicyUrl'));
    }
    if (this.form.getValue('parentsPrivacyPolicyUrl')) {
      formData.append('parentsPrivacyPolicyUrl', this.form.getValue('parentsPrivacyPolicyUrl'));
    }
    if (isBoolean(this.form.getValue('isNewStudentAppEnabled'))) {
      formData.append('isNewStudentAppEnabled', this.form.getValue('isNewStudentAppEnabled'));
    }
    if (this.form.getValue('kidsLogo')) {
      formData.append('kidsLogoFile', this.form.getValue('kidsLogo'));
    }
    if (this.form.getValue('favicon')) {
      formData.append('favIconFile', this.form.getValue('favicon'));
    }
    if (this.form.getValue('icon')) {
      formData.append('iconFile', this.form.getValue('icon'));
    }
    if (this.form.getValue('whiteIcon')) {
      formData.append('whiteIconFile', this.form.getValue('whiteIcon'));
    }
    if (this.form.getValue('iosIcon')) {
      formData.append('iosIconFile', this.form.getValue('iosIcon'));
    }
    if (this.form.getValue('androidIcon')) {
      formData.append('androidIconFile', this.form.getValue('androidIcon'));
    }
    if (this.form.getValue('mobileSplashScreen')) {
      formData.append('mobileSplashScreenFile', this.form.getValue('mobileSplashScreen'));
    }
    if (this.form.getValue('distributor')) {
      formData.append('distributor', this.form.getValue('distributor'));
    }
    if (this.form.getValue('company')) {
      formData.append('company', this.form.getValue('company'));
    }
    if (this.form.getValue('supportEmail')) {
      formData.append('supportEmail', this.form.getValue('supportEmail'));
    }

    this.submit
      .fetch({
        method: whitelabelConfigId ? 'put' : 'post',
        url: whitelabelConfigId ? `/whitelabel-configs/${whitelabelConfigId}` : '/whitelabel-configs',
        body: formData,
      })
      .then(() => {
        if (this.submit.data) {
          browserHistory.push(`/whitelabel-configs/${this.submit.data.id}`);
          this.handleLoad(this.submit.data.id);
          NotificationService.addNotification(
            `Whitelabel configuration ${whitelabelConfigId ? 'updated' : 'created'} successfully.`,
            'success'
          );
        }
        if (this.submit.error) {
          NotificationService.addNotification(
            `Error ${whitelabelConfigId ? 'updating' : 'creating'} whitelabel configuration.`,
            'error'
          );
        }
      });
  });
}
